<template>
  <div class="faq-detail">
    <div class="top-nav">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('FAQ') }}</h1>
      <div class="placeholder"></div>
    </div>

    <div class="faq-wrap">
      <div v-if="loading" class="faq-empty">{{ $t('Loading...') }}</div>
      <div v-else-if="error" class="faq-empty">{{ error }}</div>
      <div v-else>
        <h2 class="faq-title">{{ info.title }}</h2>
        <div class="faq-content" v-html="info.content"></div>
      </div>
    </div>

    <div class="faq-bottom">
      <button type="button" class="cs-go" @click="goKefu">{{ $t('Contact Customer Service') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faqDetail',
  data() {
    return {
      loading: false,
      error: '',
      info: { title: '', content: '' },
    };
  },
  created() {
    this.loadDetail();
  },
  methods: {
    loadDetail() {
      const id = this.$route.query.id || this.$route.params.id;
      if (!id) {
        this.error = this.$t('No FAQ yet');
        return;
      }
      this.loading = true;
      const lang = (this.$i18n && this.$i18n.locale) || 'pt';
      this.$apiFun.post('/api/faq/detail', { id, lang }).then((res) => {
        this.loading = false;
        if (res.code === 200) {
          this.info = res.data || {};
        } else {
          this.error = res.message || this.$t('No FAQ yet');
        }
      }).catch(() => {
        this.loading = false;
        this.error = this.$t('No FAQ yet');
      });
    },
    goKefu() {
      const cached =
        (this.$store.state.appInfo &&
          (this.$store.state.appInfo.service_link || this.$store.state.appInfo.kf_url)) ||
        '';
      const url = this.fillKfUrl(cached);
      if (url) {
        try {
          const u = new URL(url, window.location.href);
          if (u.protocol === 'http:' || u.protocol === 'https:') {
            window.location.href = url;
            return;
          }
        } catch (e) { /* fall through */ }
      }
      this.$router.push('/kefu').catch(() => {});
    },
    fillKfUrl(url) {
      const u = (this.$store && this.$store.state && this.$store.state.userInfo) || {};
      const id = String(u.id || u.userid || u.user_id || '');
      const name = encodeURIComponent(u.username || u.account || u.name || '');
      return String(url || '')
        .replace(/\{visiter_id\}/gi, id)
        .replace(/\{visiter_name\}/gi, name)
        .replace(/\{uid\}/gi, id)
        .replace(/\{userid\}/gi, id)
        .replace(/\{user_id\}/gi, id)
        .replace(/\{name\}/gi, name)
        .replace(/\{username\}/gi, name);
    },
  },
};
</script>

<style scoped>
.faq-detail {
  min-height: 100vh;
  background: #f6efe4;
  color: #3d2a12;
}

.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(180deg, #fff8ea 0%, #f3e2c4 100%);
  border-bottom: 1px solid #ead1b2;
  position: sticky;
  top: 0;
  z-index: 20;
}

.top-nav h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #8f501f;
}

.back,
.placeholder {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back i {
  font-size: 20px;
  color: #8f501f;
}

.faq-wrap {
  padding: 18px 16px 100px;
}

.faq-title {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 800;
  color: #5a3512;
}

.faq-content {
  font-size: 14px;
  line-height: 1.7;
  color: #5c4328;
}

.faq-empty {
  padding: 40px 0;
  text-align: center;
  color: #9a7b55;
}

.faq-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: rgba(246, 239, 228, 0.94);
}

.cs-go {
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 22px;
  color: #4a2e00;
  font-size: 15px;
  font-weight: 800;
  background: linear-gradient(145deg, #ffe082 0%, #d1a03e 55%, #b8860b 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/faqDetail.vue